/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Dataset = {
    properties: {
        label: {
    type: 'string',
    isRequired: true,
},
        backgroundColor: {
    type: 'string',
    isRequired: true,
},
        data: {
    type: 'array',
    contains: {
    type: 'number',
},
    isRequired: true,
},
    },
};